import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="footer_inner">
          <p>Smart Docustore Ltd© 2021</p>
          <ul>
            <li><a href="https://smart-formation.smart-doc.co.uk/extra/terms.html" target="_blank" rel="noreferrer">Terms and Conditions</a></li>
            <li><a href="https://smart-formation.smart-doc.co.uk/extra/privacy.html" target="_blank" rel="noreferrer">GDPR Privacy Policy</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
